<template>
  <div>

    <OilDataCap v-if='contracts'
                :title='capTitle.toUpperCase()'
                :buttons='capButtons'
                service-name="contract"
                :search-filter="onSearchValueChange"
    />
    <v-divider class="my-2"/>
    <loading v-if='loadingPage'/>


    <OilDataTable v-else
                  :keys='tableKey'
                  :items='contracts'
                  :paginate='count'
                  :item-counts="contracts.length+1"
                  :hide-footer="true"
                  @paginateAction='paginate'
                  :color='color'
    >

      <template v-slot:CompanyName='{value}'>
        {{ value }}
      </template>

      <template v-slot:TaxNo='{value}'>
        {{ value }}
      </template>

      <template v-slot:SignedDate='{value}'>
        {{ value | date }}
        <br/>
        <small class='grey--text'>
          {{ value | time }}
        </small>
      </template>

      <template v-slot:Status='{value,object}'>
        <v-chip
            class='ma-2'
            :color='colorStatus(value)'
            small
        >
          {{ object.Status }}
        </v-chip>
      </template>

      <template v-slot:PDFID='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn class='mx-6' type='button' icon
                   @click="showMePdf('contract/print',value)"
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>
                mdi-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>СКАЧАТЬ И ПЕЧАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Id='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-bind='attrs'
                   v-on='on' icon
                   @click.stop='handleRowClick(value)'>
              <v-icon color='primary'>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>

      <template v-slot:DeleteId='{value}'>
        <v-row>
          <v-col
              md="6"
              offset-md="3"
          >
            <oil-modal
                :value='value'
                tooltipMessage='УДАЛИТЬ'
                mdiIcon='mdi-delete'
                :accept='deleteContract'
            />
          </v-col>
        </v-row>

      </template>


    </OilDataTable>

  </div>
</template>

<script>

import {contractsService} from '@/services/ContractsService'
import {cap, table} from '../setting/contracts.json'
import loading from '@/components/helper/oil.loading'
import {coreApi} from '@/services/core'

export default {
  components: {
    OilDataTable: () => import('@/components/helper/oil.table'),
    OilDataCap: () => import('@/components/helper/oil.cap'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal'),
    loading: loading
  },
  data: () => ({
    capTitle: cap.title,
    capButtons: cap.buttons,
    tableKey: table.keys,
    contracts: null,
    loadingPage: true,
    statusLocal: {
      active: 'Активный',
      notsigned: 'Неподписанный',
      special: 'Особый',
      inactive: 'Неактивный'
    },
    count: {
      count: 0
    }
  }),

  async created() {
    this.tableKey = this.tableKey?.map(key => {
      return {
        text: key.text.toUpperCase(),
        value: key.value
      }
    })
    await this.paginate((this.currentPage - 1) * 10)
    this.loadingPage = false
  },

  methods: {
    openPdf(id, path) {
      window.open(process.env.VUE_APP_BACKEND_API + `/${path}/${id}`)
    },
    async handleRowClick(id) {
      await this.$router.push(`/contract/${id}`)
    },
    async paginate(page) {
      const contracts = await contractsService.paginate(page)
      const {count, dates} = contracts.data
      this.count.count = count
      this.contracts = dates?.map(contract => {
        return {
          PDFID: contract?.Id,
          Id: contract?.Id,
          DeleteId: contract?.Id,
          UpdateId: contract?.Id,
          CompanyName: contract?.Buyer?.CompanyName,
          Number: contract?.Number,
          TaxNo: contract?.Buyer?.TaxNo,
          SignedDate: contract?.StartDate,
          Balance: contract?.Balance,
          Status: this.statusLocal[contract.Status]
        }
      }) || []
    },
    colorStatus(val) {
      if (val === 'Активный') {
        return 'success'
      } else if (val === 'Неактивный') {
        return 'red'
      } else if (val === 'Особый') {
        return 'warning'
      } else if (val === 'Неподписанный') {
        return 'lime'
      }
    },

    async deleteContract(id) {
      const response = await contractsService.delete(id)
      const isDelete = response.data
      if (isDelete) {
        const contract = this.contracts.find(({Id}) => Id === id)
        const index = this.contracts.indexOf(contract)
        this.contracts.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `Договор под номером ${contract.Number} удачно удален`
        })
      }
    },
    async onSearchValueChange(data) {
      if (!data) {
        await this.paginate((this.currentPage - 1) * 10)
        return
      }
      this.contracts = data?.map(contract => {
        return {
          PDFID: contract?.Id,
          Id: contract?.Id,
          DeleteId: contract?.Id,
          UpdateId: contract?.Id,
          CompanyName: contract?.Buyer?.CompanyName,
          Number: contract?.Number,
          TaxNo: contract?.Buyer?.TaxNo,
          SignedDate: contract?.StartDate,
          Balance: contract?.Balance,
          Status: this.statusLocal[contract.Status]
        }
      })
    },
    color: (item) => !item ? null : (item.Balance < 0 ? 'red-color' : null)
  },
  getPdf(id) {
    return coreApi({
      url: `http://localhost:5000/api/contract/print/${id}`,
      responseType: 'blob',
      method: 'GET'
    }).then((response) => {
      this.url = window.URL.createObjectURL(response.data)
      setTimeout(() => {
        document.querySelector('embed').src = this.url
      })
    }).catch(function (error) {
      window.console.log(error)
    })
  }

}
</script>